import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

// Core Components
import MDCButton from "../core/MDCButton";
import MDCModal from "../core/MDCModal";

// Theme
import theme from "../../themes/mdc-theme";

// Assets
import carLogo from "../../assets/images/my_digital_car.svg";
import iconWarningInfo from "../../assets/images/icon_warning_info.svg";

const DeleteProviderFlow = (props) => {
  const qesVendorCancelBody = () => (
    <Grid container padding={"2rem"} justifyContent="center">
      <Grid container>
        <Grid item xs={7} display="flex" alignItems="center">
          <h5 style={{ color: theme.palette.MDCColors.black }}>
            Signaturvorgang abbrechen
          </h5>
        </Grid>
        <Grid item xs={5}>
          <img
            alt="My Digital Car"
            src={carLogo}
            width="95%"
            style={{ maxWidth: "100% !important", marginRight: "2%" }}
          />
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="center"
        margin={"2rem 0"}
      >
        <img alt="vollmachtLoschen" src={iconWarningInfo} />
      </Grid>
      <Grid
        item
        xs={12}
        margin={"1rem 0"}
        style={{
          fontFamily: theme.palette.typography.fontFamily,
          color: theme.palette.MDCColors.color15,
          textAlign: "center",
        }}
      >
        Sind Sie sicher, dass Sie den Signaturvorgang abbrechen möchten?
        <br /> <br />
        Alle nicht gespeicherten Einstellungen und hochgeladenen Dokumente gehen
        verloren. Sie werden anschließend zur Anbieterauswahl zurückgeleitet.
      </Grid>

      <Grid container justifyContent={"space-between"} marginTop="2.5rem">
        <MDCButton
          variant="outlined"
          label={"Abbrechen"}
          onClick={() => props.handleHideQESVendorCancelConfirm()}
        />
        <MDCButton
          variant="outlined"
          label={"Bestätigen"}
          onClick={() => props.handleQESVendorConfirm()}
        />
      </Grid>
    </Grid>
  );

  return (
    <MDCModal
      open={props.showQESVendorCancelConfirm}
      onClose={() => props.handleHideQESVendorCancelConfirm()}
      body={qesVendorCancelBody()}
      size="sm"
    />
  );
};

DeleteProviderFlow.propTypes = {
  showQESVendorCancelConfirm: PropTypes.bool.isRequired,
  handleQESVendorConfirm: PropTypes.func.isRequired,
  handleHideQESVendorCancelConfirm: PropTypes.func.isRequired,
};

export default DeleteProviderFlow;
